import { render, staticRenderFns } from "./GoodsClassForm.vue?vue&type=template&id=3be6f696&scoped=true&"
import script from "./GoodsClassForm.vue?vue&type=script&lang=js&"
export * from "./GoodsClassForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClassForm.vue?vue&type=style&index=0&id=3be6f696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be6f696",
  null
  
)

export default component.exports